import _get from 'lodash/get';
import base64 from 'base-64';
import bytes from 'bytes';
import ms from 'ms';

export function promisify(fn) {
  return new Promise((resolve, reject) => {
    fn((err, res) => {
      if (err) {
        reject(err);
      } else {
        resolve(res);
      }
    });
  });
}

export function promiseEachSeries(array, eachFn) {
  return array.reduce((p, v, i) => p.then(() => eachFn(v, i)), Promise.resolve());
}

export function promiseMapSeries(array, mapFn) {
  return array.reduce((p, v, i) => p.then(async r => r.concat(await mapFn(v, i))), Promise.resolve([]));
}

export function promiseReduceSeries(array, reduceFn, startValue) {
  return array.reduce((p, v, i) => p.then(r => reduceFn(r, v, i)), Promise.resolve(startValue || array[0] || null));
}

export function formatErr(err, props) {
  if (!(err instanceof Error)) {
    err = new Error(err);
  }

  for (const key in props) {
    if (key !== 'status' && key !== 'statusCode') {
      err[key] = props[key];
    }
  }

  return err;
}

export function matchGraphQLError(err, key, value) {
  return err && Array.isArray(err.graphQLErrors) ? err.graphQLErrors.find(e => _get(e, key) === value) : null;
}

export function toDataURI(type, decoded) {
  return `data:${type};base64,${base64.encode(decoded)}`;
}

export function fromDataURI(uri) {
  if (`${uri}`.indexOf('data:')) {
    const [ , encoded ] = uri.substr('data:'.length).split(',');
    return base64.decode(encoded);
  }
}

export function chunkArrayInBytes(input, maximum) {
  input = input.slice(0);
  maximum = bytes(maximum);

  if (Array.isArray(input) && input.length) {
    const out = [ [] ];
    let buf = 0;

    while (input.length) {
      const line = input.shift();
      buf += Buffer.byteLength(JSON.stringify(line), 'utf8');

      if (buf > maximum) {
        out.push([]);
        buf = 0;
      }

      out[out.length - 1].push(line);
    }

    return out;
  } else {
    return [];
  }
}

export function tryNull(fn) {
  try {
    return fn();
  } catch (err) {
    return null;
  }
}

export function wait(time = '1s') {
  return Promise.resolve(resolve => setTimeout(() => resolve(), ms(time)));
}

export function sanitiseTags(tagsList = []) {
  return tagsList.map(t => `#${t}`).join(' ');
}

export function hasTimePassed(timestamp, timeInSeconds) {
  const currentTime = Date.now(); // Current time in milliseconds
  const targetTime = timestamp + timeInSeconds * 1000; // Convert seconds to milliseconds
  return currentTime >= targetTime;
};


// WEBPACK FOOTER //
// ./src/lib/utils.js